// When adding a surface here, be sure to also add it to the proper category(s) below
export var EventSurface;
(function (EventSurface) {
    EventSurface["INTRO"] = "INTRO";
    EventSurface["ABOUT_INFO"] = "ABOUT_INFO";
    EventSurface["BANK_INFO_INPUT"] = "BANK_INFO_INPUT";
    EventSurface["BANK_INFO_CONFIRMATION"] = "BANK_INFO_CONFIRMATION";
    EventSurface["TERMS_OF_SERVICE"] = "TERMS_OF_SERVICE";
    EventSurface["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    EventSurface["EXIT_CONFIRMATION"] = "EXIT_CONFIRMATION";
    EventSurface["EXIT_CONFIRMATION_ALT"] = "EXIT_CONFIRMATION_ALT";
    EventSurface["SEARCH_DEFAULT"] = "SEARCH_DEFAULT";
    EventSurface["SEARCH_RESULTS"] = "SEARCH_RESULTS";
    EventSurface["SEARCH_ERROR"] = "SEARCH_ERROR";
    EventSurface["SEARCH_PLATFORM_ONLY"] = "SEARCH_PLATFORM_ONLY";
    EventSurface["SEARCH_WORKDAY_ONLY"] = "SEARCH_WORKDAY_ONLY";
    EventSurface["LOGIN"] = "LOGIN";
    EventSurface["LOGIN_ERROR"] = "LOGIN_ERROR";
    EventSurface["LOGIN_CONFIRMATION"] = "LOGIN_CONFIRMATION";
    EventSurface["ADP_IFRAME"] = "ADP_IFRAME";
    EventSurface["ACCOUNT_RECOVERY"] = "ACCOUNT_RECOVERY";
    EventSurface["ACCOUNT_RECOVERY_ERROR"] = "ACCOUNT_RECOVERY_ERROR";
    EventSurface["ACCOUNT_RECOVERY_CONFIRMATION"] = "ACCOUNT_RECOVERY_CONFIRMATION";
    EventSurface["DD_PAYMENT"] = "DD_PAYMENT";
    EventSurface["JOB_ERROR"] = "JOB_ERROR";
    EventSurface["MODAL_INITIALIZATION"] = "MODAL_INITIALIZATION";
    EventSurface["LOADING"] = "LOADING";
    EventSurface["REAUTH"] = "REAUTH";
    EventSurface["REAUTH_ERROR"] = "REAUTH_ERROR";
    EventSurface["MANUAL_INSTRUCTIONS"] = "MANUAL_INSTRUCTIONS";
    EventSurface["MANUAL_INSTRUCTIONS_FALLBACK"] = "MANUAL_INSTRUCTIONS_FALLBACK";
    EventSurface["MULTIPLE_ACCOUNTS_SELECTION"] = "MULTIPLE_ACCOUNTS_SELECTION";
    EventSurface["ALLOCATION_VIEWING"] = "ALLOCATION_VIEWING";
    EventSurface["ALLOCATION_VIEWING_LOADING"] = "ALLOCATION_VIEWING_LOADING";
    EventSurface["ALLOCATION_VIEWING_ERROR"] = "ALLOCATION_VIEWING_ERROR";
    EventSurface["INVALID_CREDENTIALS_ERROR"] = "INVALID_CREDENTIALS_ERROR";
    EventSurface["DD_FORM_PRIMER"] = "DD_FORM_PRIMER";
    EventSurface["EMPLOYER_INPUT"] = "EMPLOYER_INPUT";
    EventSurface["NAME_INPUT"] = "NAME_INPUT";
    EventSurface["DD_AMOUNT_SELECTION"] = "DD_AMOUNT_SELECTION";
    EventSurface["DD_CONFIRMATION"] = "DD_CONFIRMATION";
    EventSurface["DD_FORM_CONFIRM"] = "DD_FORM_CONFIRM";
    EventSurface["PII_NAME_ENTRY"] = "PII_NAME_ENTRY";
    EventSurface["PII_TEL_ENTRY"] = "PII_TEL_ENTRY";
    EventSurface["PII_DOB_ENTRY"] = "PII_DOB_ENTRY";
    EventSurface["PII_SSN4_ENTRY"] = "PII_SSN4_ENTRY";
    EventSurface["PII_SSN9_ENTRY"] = "PII_SSN9_ENTRY";
    EventSurface["PII_REVIEW"] = "PII_REVIEW";
    EventSurface["JOB_SUCCESS"] = "JOB_SUCCESS";
    EventSurface["SIGNATURE_SELECTION"] = "SIGNATURE_SELECTION";
    EventSurface["DD_FORM_SUCCESS"] = "DD_FORM_SUCCESS";
    EventSurface["PROVIDER_CONFIRMATION_BOUNDED"] = "PROVIDER_CONFIRMATION_BOUNDED";
    EventSurface["PROVIDER_CONFIRMATION_UNBOUNDED"] = "PROVIDER_CONFIRMATION_UNBOUNDED";
    EventSurface["PROVIDER_CONFIRMATION_PRIMER"] = "PROVIDER_CONFIRMATION_PRIMER";
    EventSurface["CARD_SWITCH_PROMPT"] = "CARD_SWITCH_PROMPT";
    EventSurface["DOCUMENT_UPLOADS_PRIMER"] = "DOCUMENT_UPLOADS_PRIMER";
    EventSurface["DOCUMENT_UPLOADS_LIST"] = "DOCUMENT_UPLOADS_LIST";
    EventSurface["DOCUMENT_UPLOADS_SUBMITTED"] = "DOCUMENT_UPLOADS_SUBMITTED";
    EventSurface["DOCUMENT_UPLOADS_REPAIR"] = "DOCUMENT_UPLOADS_REPAIR";
    EventSurface["DOCUMENT_UPLOADS_DELETE"] = "DOCUMENT_UPLOADS_DELETE";
    EventSurface["GUIDED_SWITCH_PRIMER"] = "GUIDED_SWITCH_PRIMER";
    EventSurface["GUIDED_SWITCH"] = "GUIDED_SWITCH";
    EventSurface["PLATFORM_ELIGIBILITY_LOOKUP_LOADING"] = "PLATFORM_ELIGIBILITY_LOOKUP_LOADING";
    EventSurface["PLATFORM_ELIGIBILITY_LOOKUP_RESULTS"] = "PLATFORM_ELIGIBILITY_LOOKUP_RESULTS";
    EventSurface["PLATFORM_ELIGIBILITY_LOOKUP_HELP"] = "PLATFORM_ELIGIBILITY_LOOKUP_HELP";
    EventSurface["DDS_IFRAME"] = "DDS_IFRAME";
    EventSurface["LOGIN_IFRAME"] = "LOGIN_IFRAME";
    EventSurface["RETURN_TO_SEARCH"] = "RETURN_TO_SEARCH";
    EventSurface["APP_CLIP_PRIMER"] = "APP_CLIP_PRIMER";
    EventSurface["WIZARD_INCOME_SOURCES"] = "WIZARD_INCOME_SOURCES";
    EventSurface["WIZARD_INCOME_SOURCE_W2"] = "WIZARD_INCOME_SOURCE_W2";
    EventSurface["WIZARD_INCOME_SOURCE_1099"] = "WIZARD_INCOME_SOURCE_1099";
    EventSurface["WIZARD_INCOME_SOURCE_BENEFITS"] = "WIZARD_INCOME_SOURCE_BENEFITS";
    EventSurface["WIZARD_PAYMENT_METHODS"] = "WIZARD_PAYMENT_METHODS";
    EventSurface["WIZARD_ERROR"] = "WIZARD_ERROR";
    EventSurface["BILL_NAVIGATOR"] = "BILL_NAVIGATOR";
})(EventSurface || (EventSurface = {}));
export var ERROR_EVENT_SOURCES = [
    EventSurface.LOGIN_ERROR,
    EventSurface.REAUTH_ERROR,
    EventSurface.JOB_ERROR,
    EventSurface.ACCOUNT_RECOVERY_ERROR,
];
export var INTRO_EVENT_SOURCES = [
    EventSurface.INTRO,
    EventSurface.ABOUT_INFO,
    EventSurface.TERMS_OF_SERVICE,
    EventSurface.PRIVACY_POLICY,
];
export var SEARCH_EVENT_SOURCES = [
    EventSurface.SEARCH_DEFAULT,
    EventSurface.SEARCH_RESULTS,
    EventSurface.SEARCH_ERROR,
    EventSurface.SEARCH_PLATFORM_ONLY,
    EventSurface.SEARCH_WORKDAY_ONLY,
];
export var LOGIN_EVENT_SOURCES = [
    EventSurface.LOGIN,
    EventSurface.LOGIN_ERROR,
    EventSurface.LOGIN_CONFIRMATION,
    EventSurface.ACCOUNT_RECOVERY,
    EventSurface.ACCOUNT_RECOVERY_ERROR,
    EventSurface.ACCOUNT_RECOVERY_CONFIRMATION,
    EventSurface.REAUTH,
    EventSurface.REAUTH_ERROR,
    EventSurface.INVALID_CREDENTIALS_ERROR,
    EventSurface.LOGIN_IFRAME,
    EventSurface.RETURN_TO_SEARCH,
    EventSurface.APP_CLIP_PRIMER,
];
export var POST_LOGIN_EVENT_SOURCES = [
    EventSurface.BANK_INFO_INPUT,
    EventSurface.BANK_INFO_CONFIRMATION,
    EventSurface.DD_CONFIRMATION,
    EventSurface.DD_PAYMENT,
    EventSurface.DD_AMOUNT_SELECTION,
    EventSurface.JOB_SUCCESS,
    EventSurface.JOB_ERROR,
    EventSurface.MULTIPLE_ACCOUNTS_SELECTION,
    EventSurface.ALLOCATION_VIEWING,
    EventSurface.ALLOCATION_VIEWING_LOADING,
    EventSurface.ALLOCATION_VIEWING_ERROR,
    EventSurface.CARD_SWITCH_PROMPT,
    EventSurface.MANUAL_INSTRUCTIONS_FALLBACK,
    EventSurface.DDS_IFRAME,
];
export var MANUAL_INSTRUCTIONS_EVENT_SOURCES = [
    EventSurface.MANUAL_INSTRUCTIONS,
];
export var BILL_NAVIGATOR_EVENT_SOURCES = [EventSurface.BILL_NAVIGATOR];
export var DIRECT_DEPOSIT_FORMS_EVENT_SOURCES = [
    EventSurface.DD_FORM_PRIMER,
    EventSurface.EMPLOYER_INPUT,
    EventSurface.NAME_INPUT,
    EventSurface.DD_AMOUNT_SELECTION,
    EventSurface.DD_FORM_CONFIRM,
    EventSurface.SIGNATURE_SELECTION,
    EventSurface.DD_FORM_SUCCESS,
];
export var PROVIDER_CONFIRMATION_EVENT_SOURCES = [
    EventSurface.PROVIDER_CONFIRMATION_BOUNDED,
    EventSurface.PROVIDER_CONFIRMATION_UNBOUNDED,
    EventSurface.PROVIDER_CONFIRMATION_PRIMER,
];
export var DOCUMENT_UPLOADS_EVENT_SOURCES = [
    EventSurface.DOCUMENT_UPLOADS_PRIMER,
    EventSurface.DOCUMENT_UPLOADS_LIST,
    EventSurface.DOCUMENT_UPLOADS_SUBMITTED,
    EventSurface.DOCUMENT_UPLOADS_REPAIR,
    EventSurface.DOCUMENT_UPLOADS_DELETE,
];
export var GUIDED_SWITCH_EVENT_SOURCES = [
    EventSurface.GUIDED_SWITCH_PRIMER,
    EventSurface.GUIDED_SWITCH,
];
export var PARTNER_PLATFORM_ELIGIBILITY_EVENT_SOURCES = [
    EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_HELP,
    EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_LOADING,
    EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_RESULTS,
];
export var WIZARD_EVENT_SOURCES = [
    EventSurface.WIZARD_ERROR,
    EventSurface.WIZARD_INCOME_SOURCES,
    EventSurface.WIZARD_INCOME_SOURCE_W2,
    EventSurface.WIZARD_INCOME_SOURCE_1099,
    EventSurface.WIZARD_INCOME_SOURCE_BENEFITS,
    EventSurface.WIZARD_PAYMENT_METHODS,
];
export var PII_DATA_EVENT_SOURCES = [
    EventSurface.PII_TEL_ENTRY,
    EventSurface.PII_NAME_ENTRY,
    EventSurface.PII_DOB_ENTRY,
    EventSurface.PII_SSN4_ENTRY,
    EventSurface.PII_SSN9_ENTRY,
    EventSurface.PII_REVIEW,
];
export var EventAction;
(function (EventAction) {
    EventAction["IMPRESSION"] = "IMPRESSION";
    EventAction["MODAL_EXIT"] = "MODAL_EXIT";
    EventAction["MODAL_BACK"] = "MODAL_BACK";
    EventAction["CONTINUE"] = "CONTINUE";
    EventAction["HINT_EXPANDED"] = "HINT_EXPANDED";
    EventAction["EXIT_EXIT"] = "EXIT_EXIT";
    EventAction["EXIT_CANCEL"] = "EXIT_CANCEL";
    EventAction["EMPLOYER_OR_PLATFORM_SELECTED"] = "EMPLOYER_OR_PLATFORM_SELECTED";
    EventAction["INCORRECT_PLATFORM"] = "INCORRECT_PLATFORM";
    EventAction["RECOVER_CREDENTIALS"] = "RECOVER_CREDENTIALS";
    EventAction["RETRY"] = "RETRY";
    EventAction["ERROR_CLOSE"] = "ERROR_CLOSE";
    EventAction["PARTIAL_SELECTED"] = "PARTIAL_SELECTED";
    EventAction["REMAINDER_SWITCH_SELECTED"] = "REMAINDER_SWITCH_SELECTED";
    EventAction["AMOUNT_SELECTED"] = "AMOUNT_SELECTED";
    EventAction["FULL_SWITCH_SELECTED"] = "FULL_SWITCH_SELECTED";
    EventAction["FULL_SELECTED"] = "FULL_SELECTED";
    EventAction["PERCENTAGE_SELECTED"] = "PERCENTAGE_SELECTED";
    EventAction["COPY_ACCOUNT_NUMBER"] = "COPY_ACCOUNT_NUMBER";
    EventAction["COPY_ROUTING_NUMBER"] = "COPY_ROUTING_NUMBER";
    EventAction["AUTO_FOCUS_TO_SEARCH"] = "AUTO_FOCUS_TO_SEARCH";
    EventAction["VIEW_ALLOCATIONS"] = "VIEW_ALLOCATIONS";
    EventAction["TAP"] = "TAP";
    EventAction["TAP_CANT_FIND"] = "TAP_CANT_FIND";
    EventAction["TAP_SEARCH"] = "TAP_SEARCH";
    EventAction["TAP_PROVIDER_SEARCH_PROMPT"] = "TAP_PROVIDER_SEARCH_PROMPT";
    EventAction["SCROLL"] = "SCROLL";
    // DD form events
    EventAction["BEGIN_FORM"] = "BEGIN_FORM";
    EventAction["SHARE"] = "SHARE";
    EventAction["DOWNLOAD"] = "DOWNLOAD";
    EventAction["EDIT_INFO"] = "EDIT_INFO";
    EventAction["EDIT_SIGNATURE"] = "EDIT_SIGNATURE";
    EventAction["SELECT_SIGNATURE"] = "SELECT_SIGNATURE";
    EventAction["GO_TO_SEARCH"] = "GO_TO_SEARCH";
    EventAction["PROVIDER_CONFIRMED"] = "PROVIDER_CONFIRMED";
    EventAction["TRY_GENERIC_PLATFORM"] = "TRY_GENERIC_PLATFORM";
    EventAction["VIEW_PROVIDER_SEARCH_PROMPT"] = "VIEW_PROVIDER_SEARCH_PROMPT";
    EventAction["IMPRESSION_NO_RESULTS"] = "IMPRESSION_NO_RESULTS";
    // card switch event actions
    EventAction["TAP_CARD_SWITCH"] = "TAP_CARD_SWITCH";
    EventAction["TAP_NO_THANKS"] = "TAP_NO_THANKS";
    EventAction["TAP_DOCUMENT_UPLOAD_BUTTON"] = "TAP_DOCUMENT_UPLOAD_BUTTON";
    EventAction["DOCUMENT_UPLOAD_FILE_SELECTED"] = "DOCUMENT_UPLOAD_FILE_SELECTED";
    EventAction["TAP_SKIP"] = "TAP_SKIP";
    EventAction["PLATFORM_ELIGIBILITY_LOOKUP_MATCH"] = "PLATFORM_ELIGIBILITY_LOOKUP_MATCH";
    // MFA event actions
    EventAction["RESEND_CODE"] = "RESEND_CODE";
    // Partner based actions
    EventAction["SHOW_POPUP_LOOKUP_FAILED"] = "SHOW_POPUP_LOOKUP_FAILED";
    EventAction["HIDE_POPUP_LOOKUP_FAILED"] = "HIDE_POPUP_LOOKUP_FAILED";
    EventAction["SHOW_POPUP_PLATFORM_MATCH_FOUND"] = "SHOW_POPUP_PLATFORM_MATCH_FOUND";
    EventAction["HIDE_POPUP_GO_TO_SEARCH"] = "HIDE_POPUP_GO_TO_SEARCH";
    EventAction["HIDE_POPUP_GO_TO_MATCH"] = "HIDE_POPUP_GO_TO_MATCH";
    EventAction["HIDE_POPUP_GO_TO_LOGIN_BASED"] = "HIDE_POPUP_GO_TO_LOGIN_BASED";
    EventAction["SHOW_POPUP_PLATFORM_LOGIN_BASED_FOUND"] = "SHOW_POPUP_PLATFORM_LOGIN_BASED_FOUND";
    // Wizard event actions
    EventAction["WIZARD_EXIT"] = "WIZARD_EXIT";
})(EventAction || (EventAction = {}));
export var EventType;
(function (EventType) {
    EventType["LINK_EVENT"] = "link_event";
    EventType["LINK_INTRO_EVENT"] = "link_intro_event";
    EventType["LINK_FF_EVENT"] = "link_feature_flag_event";
    EventType["LINK_LAUNCH_EVENT"] = "link_launch_event";
    EventType["LINK_SEARCH_EVENT"] = "link_search_event";
    EventType["LINK_LOGIN_EVENT"] = "link_login_event";
    EventType["LINK_POST_LOGIN_EVENT"] = "link_post_login_event";
    EventType["LINK_BACKGROUNDED"] = "link_backgrounded_event";
    EventType["LINK_FOREGROUNDED"] = "link_foregrounded_event";
    EventType["MANUAL_INSTRUCTIONS_EVENT"] = "link_manual_instructions_event";
    EventType["LINK_DIRECT_DEPOSIT_FORMS_EVENT"] = "link_direct_deposit_forms_event";
    EventType["LINK_PROVIDER_CONFIRMATION_EVENT"] = "link_provider_confirmation_event";
    EventType["LINK_DOCUMENT_UPLOADS_EVENT"] = "link_document_uploads_event";
    EventType["LINK_GUIDED_SWITCH_EVENT"] = "link_guided_switch_event";
    EventType["LINK_PARTNER_ELIGIBILITY_EVENT"] = "link_partner_eligibility_check_event";
    EventType["LINK_WIZARD_EXIT"] = "link_wizard_exit";
    EventType["LINK_COLLECT_PII_DATA_EVENT"] = "link_collect_pii_data_event";
})(EventType || (EventType = {}));
